export const portfolioMobileGap = '1.5em';
